import { Pages } from "../../../utils";
import { ActionButton } from "../components/Button";
import { IconArrowRight } from "../components/Icons";

type MatchCtaSectionProps = {
  title: string;
  subtitle: string;
  className?: string;
};

export const MatchCtaSection = ({
  title,
  subtitle,
  className,
}: MatchCtaSectionProps) => (
  <section className={["sg-section sg-cta", className].filter(Boolean).join(" ")}>
    <div className="sg-container">
      <div className="sg-cta__content">
        <h2 className="sg-section__title sg-section__title--light sg-cta__title">
          {title}
        </h2>
        <p className="sg-section__subtitle sg-section__subtitle--light sg-cta__subtitle">
          {subtitle}
        </p>
        <div className="sg-cta__actions">
          <ActionButton
            variant="light"
            size="md"
            to={`${Pages.SIGNUP}?userType=Homeowner`}
          >
            For Homeowners <IconArrowRight size={16} />
          </ActionButton>
          <ActionButton
            variant="light"
            size="md"
            to={`${Pages.SIGNUP}?userType=Designer`}
          >
            For Interior Designers <IconArrowRight size={16} />
          </ActionButton>
        </div>
      </div>
    </div>
  </section>
);
